/* External */
import {
  memo, useEffect, useState, useRef,
} from 'react';
import { Redirect } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import { getProfilesAPI } from '../../../services/profiles';

/* Providers */
import { useInterstitialInfo } from '../../../providers/InterstitialProvider';
import { useLoading } from '../../../providers/LoadingProvider';
import { useIsUpdatingUserCustomData } from '../../../providers/UserProvider';
import { useTermsOfServiceInfo } from '../../../providers/TermsOfServiceProvider';

/* Utils */
import { getLink, Routes } from '../../../utils/router';
import { getProfiles } from '../../../storage/profiles/actions';

function ValidationPage() {
  const { showLoading, hideLoading } = useLoading();

  const isUpdatingUser = useIsUpdatingUserCustomData();

  const userProfiles = useSelector((state) => state?.profile?.profiles) ?? JSON.parse(localStorage.getItem('profiles'));
  const [profiles, setProfiles] = useState(userProfiles);
  const [isLoadingProfiles, setIsLoadingProfiles] = useState(!userProfiles);
  const dispatch = useDispatch();

  const loading = useRef(true);

  const {
    isLoading: isLoadingInterstitial,
    shouldDisplay: shouldDisplayInterstitial,
  } = useInterstitialInfo();

  const { isLoadingShouldAccept } = useTermsOfServiceInfo();

  useEffect(() => {
    if (!profiles) {
      getProfilesAPI().then((res) => {
        setProfiles(res.data);
        getProfiles(dispatch(res.data));
        setIsLoadingProfiles(false);
        loading.current = !loading.current;
        return undefined;
      }).catch((error) => {
        console.error(error);
        setIsLoadingProfiles(false);
      });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps
        -- we only want to fetch profiles if they are not already there
        TODO: Fix this, it's very ugly */
  }, []);

  useEffect(() => {
    let timeout = setTimeout(() => {
      timeout = undefined;
      showLoading();
    }, 100);
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = undefined;
      } else {
        hideLoading();
      }
    };
  }, [hideLoading, showLoading]);

  useEffect(() => {
    setTimeout(() => {
      hideLoading();
    }, 1000);
    clearTimeout();
  }, [hideLoading]);

  if (isLoadingInterstitial || isUpdatingUser || isLoadingShouldAccept || isLoadingProfiles) {
    // eslint-disable-next-line unicorn/no-null -- React does not support undefined
    return null;
  }

  if (shouldDisplayInterstitial) {
    return <Redirect to={getLink(Routes.Private.Interstitial)} />;
  }

  if (profiles?.length) {
    loading.current = !loading.current;
    return <Redirect to={getLink(Routes.Private.Profiles)} />;
  }

  loading.current = !loading.current;

  return <Redirect to={getLink(Routes.Private.Onboarding)} />;
}

export default memo(ValidationPage);
